import CTLDate from "application/components/CTLDate";
import DefaultCell from "application/components/DefaultCell";
import RowAction from "application/components/RowAction";
import { adminMenus } from "globals/configuration/admin";
import CTLDay from "../CTLDay";
import formControl from "globals/form-control";
import { useState } from "react";
import CTLDateView from "../CTLDateView";
import CTLNONWorkingAction from "application/components/CTLNONWorking";

const Attributes = {
  formSize: "lg",
  enableAddButton: true,
  enableAdvanceSearch: true,
  enableDownloadPdf: true,
  enableMultipleDeleteButton: true,
  ButtonNames:"Delete All Record",
  modes: adminMenus.map((item) => {
    return {
      id: item.key,
      name: item.name,
      iconName: item.icon,
      url: item.url,
      description: item.description,
      disabled: item.disabled,
      productionReady: item.productionReady,
    };
  }),
  settingsMode: false,
};

const operationURLS = {
  list: "non-holiday/list",
  update: "non-holiday/update",
  create: "non-holiday/create",
  yearlyCreate: "non-holiday/yearlyCreate",
  delete: "non-holiday/delete",
  crateSingle: "non-holiday/createSingle",
  pdfDownload: "non-holiday/generateAndDownloadPdf",
  deleteAll: "non-holiday/deleteAll",
  isActive: "non-holiday/isActiveToggle",
};

const getColumns = (onDelete, onEdit, onCreate, onDeactivate) => {
  const [isEnable, setIsEnable] = useState(false);
  const onChangeServingApp = (event, formik) => {
    console.log(event.target.value);
    if (event.target.value == "transfer") {
      setIsEnable(true);
    } else {
      setIsEnable(false);
    }
  };
  return [
    {
      Header: "Sun",
      accessor: "sunday",
      displayInList: false,
      allowInForm: true,
      allowFilter: false,
      dataType: "integer",
      controlType: "checkbox",
      Cell: ({ value }) => <DefaultCell value={value} />,
      width: 1.7,
    },
    {
      Header: "Mon",
      accessor: "monday",
      displayInList: false,
      allowInForm: true,
      allowFilter: false,
      dataType: "integer",
      controlType: "checkbox",
      Cell: ({ value }) => <DefaultCell value={value} />,
      width: 1.7,
    },
    {
      Header: "Tue",
      accessor: "tuesday",
      displayInList: false,
      allowInForm: true,
      allowFilter: false,
      dataType: "integer",
      controlType: "checkbox",
      Cell: ({ value }) => <DefaultCell value={value} />,
      width: 1.7,
    },
    {
      Header: "Wed",
      accessor: "wednesday",
      displayInList: false,
      allowInForm: true,
      allowFilter: false,
      dataType: "integer",
      controlType: "checkbox",
      Cell: ({ value }) => <DefaultCell value={value} />,
      width: 1.7,
    },
    {
      Header: "Thu",
      accessor: "thursday",
      displayInList: false,
      allowInForm: true,
      allowFilter: false,
      dataType: "integer",
      controlType: "checkbox",
      Cell: ({ value }) => <DefaultCell value={value} />,
      width: 1.7,
    },
    {
      Header: "Fri",
      accessor: "friday",
      displayInList: false,
      allowInForm: true,
      allowFilter: false,
      dataType: "integer",
      controlType: "checkbox",
      Cell: ({ value }) => <DefaultCell value={value} />,
      width: 1.7,
    },
    {
      Header: "Sat",
      accessor: "saturday",
      displayInList: false,
      allowInForm: true,
      allowFilter: false,
      dataType: "integer",
      controlType: "checkbox",
      Cell: ({ value }) => <DefaultCell value={value} />,
      width: 1.7,
    },

    {
      Header: "Day",
      accessor: "day",
      displayInList: true,
      allowInForm: false,
      allowFilter: false,
      dataType: "string",
      Cell: ({ value }) => <CTLDay value={value} />,
      width: 6,
    },
    {
      Header: "Date",
      accessor: "date",
      displayInList: true,
      allowInForm: false,
      allowFilter: true,
      dataType: "date",
      validation: formControl.string().required("Required"),
      Cell: ({ value }) => <DefaultCell value={value} />,
      width: 6,
    },
    {
      Header: "Holiday Name",
      accessor: "holidayName",
      displayInList: true,
      allowInForm: false,
      allowFilter: false,
      dataType: "string",
      Cell: ({ value }) => <DefaultCell value={value} />,
      validation: formControl.string().required("Required"),
      width: 6,
    },
    {
      Header: "Created On",
      accessor: "createdOn",
      displayInList: false,
      allowInForm: false,
      allowFilter: false,
      Cell: ({ value }) => <CTLDate value={value} />,
      width: 6,
    },
    {
      Header: "From Time",
      accessor: "fromTime",
      displayInList: true,
      allowInForm: true,
      allowFilter: false,
      dataType: "string",
      controlType: "time",
      validation: formControl.string().required("Required"),
      Cell: ({ value }) => <DefaultCell value={value} />,
      width: 6,
    },
    {
      Header: "To Time",
      accessor: "toTime",
      displayInList: true,
      allowInForm: true,
      allowFilter: false,
      dataType: "string",
      controlType: "time",
      validation: formControl.string().required("Required"),
      Cell: ({ value }) => <DefaultCell value={value} />,
      width: 6,
    },
    {
      Header: "Serving App (transfer type)",
      accessor: "servingApp",
      displayInList: true,
      allowInForm: true,
      allowFilter: false,
      dataType: "string",
      Cell: ({ value }) => <DefaultCell value={value} />,
      width: 6,
      controlType: "select",
      onChange: onChangeServingApp,
      validation: formControl.string().required("Required"),
      options: {
        keyField: "id",
        keyDescription: "description",
        values: [
          { id: "hangup", description: "Hangup" },
          { id: "transfer", description: "Transfer" },
          { id: "extensionMode", description: "Extension Mode" },
        ],
        url: "",
      },
    },
    {
      Header: "Serving Data (transfer number)",
      accessor: "servingData",
      displayInList: true,
      allowInForm: isEnable,
      allowFilter: false,
      dataType: "string",
      validation: formControl.string().digitsOnly().required("Required"),
      Cell: ({ value }) => <DefaultCell value={value} />,
      width: 6,
    },

    {
      Header: "Action",
      accessor: "id",
      displayInList: true,
      allowInForm: false,
      Cell: ({ row, value }) => (
        <CTLNONWorkingAction
          row={row}
          value={value}
          onDelete={onDelete}
          onEdit={onEdit}
          onAdd={onCreate}
          onDeactivate={onDeactivate}
        />
      ),
    },
  ];
};

export { getColumns, Attributes, operationURLS };
